import { Component } from '@angular/core';

@Component({
  templateUrl: '500.component.html'
})
export class P500View {

  constructor() { }

}



// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/views/pages/500.component.ts